import { BoilerAdapter, HeatingCircuit, IOExtension, RelayControl, WiredTemperatureSensor, } from 'z3k-config';
import { getIOExtensionSpecByBlockId } from 'z3k-parser/model/device-spec/io-extensions-spec';
import { getAllUsedIO } from 'z3k-parser/lib/input-outputs/get';
import { getZ3kEntityById, objects2ids } from 'z3k-parser/lib';
import { boiler_id_2_adapter_slot, boiler_id_2_relay_id, } from 'console/climatic/constants';
export function getUsedIOList(config, device_spec, io_ext_ids) {
    let result = [];
    const { busy_output_pins, busy_input_pins } = getAllUsedIO(config, device_spec);
    result = [...busy_input_pins, ...busy_output_pins].reduce((_res, pin) => {
        const { obj_type, blockId, pinNumber, obj_name, is_inverse } = pin;
        if (io_ext_ids.length == 0 //проверяем на встроенные IO (H2000+)
            ? blockId !== null
            : !io_ext_ids.includes(blockId)) {
            return _res;
        }
        const used_io_item = {
            obj_name,
            io_name: getNameFromSpec(pinNumber, blockId),
            obj_type,
        };
        //для климатика выкидываем реле, относящиеся к котлам. Добавим их позже.
        if (device_spec.io.has_graph_panel_climatic && obj_type == 'relay_controls') {
            const relay = RelayControl.get.one(config, (relay) => relay.name == obj_name);
            if (relay && [20494, 20488, 20495, 20489].includes(relay.id)) {
                return _res;
            }
        }
        if (obj_type == 'relay_controls' && is_inverse) {
            used_io_item.io_name += ' - инверсия';
            used_io_item.is_inverse = is_inverse;
        }
        if (obj_type == 'pumps' && is_inverse) {
            used_io_item.io_name += ' - инверсия';
            used_io_item.is_inverse = is_inverse;
        }
        if (obj_type == 'threeway_taps') {
            if (is_inverse) {
                used_io_item.io_name += ' - закрытие';
            }
            else {
                used_io_item.io_name += ' - открытие';
            }
            used_io_item.is_inverse = is_inverse;
        }
        return [..._res, used_io_item];
    }, result);
    const io_extensions = objects2ids(IOExtension.get.where(config, IOExtension.isBuiltIn));
    result = BoilerAdapter.get
        .where(config, BoilerAdapter.isEnabled)
        .reduce((acc, current) => {
        if (io_ext_ids.length > 0 &&
            io_ext_ids.every((id) => !io_extensions.includes(id))) {
            return acc;
        }
        const used_io_item = {
            obj_name: current.name,
            io_name: BoilerAdapter.getNameForIO(current),
            obj_type: 'boiler_adapters',
        };
        return [...acc, used_io_item];
    }, result);
    if (device_spec.io.has_graph_panel_climatic) {
        result = HeatingCircuit.get
            .where(config, (hc) => HeatingCircuit.isEnabled(hc) && HeatingCircuit.isBoiler(hc))
            .reduce((acc, hc) => {
            hc.control_devices.map((obj_id) => {
                const [obj_type, obj] = getZ3kEntityById(config, obj_id);
                const _obj = obj;
                if (obj_type && obj_type == 'boiler_adapters') {
                    const boiler_adapter_slot = boiler_id_2_adapter_slot(hc.id);
                    if (_obj.slot == boiler_adapter_slot) {
                        const used_io_item = {
                            obj_name: _obj.name,
                            io_name: BoilerAdapter.getNameForIO(_obj),
                            obj_type: 'boiler_adapters',
                        };
                        return [...acc, used_io_item];
                    }
                }
                if (obj_type && obj_type == 'relay_controls') {
                    const relay_id = boiler_id_2_relay_id(hc.id);
                    if (obj_id == relay_id) {
                        const used_io_item = {
                            obj_name: _obj.name,
                            io_name: BoilerAdapter.getNameForIO(_obj),
                            obj_type: 'relay_controls',
                        };
                        return [...acc, used_io_item];
                    }
                }
                return acc;
            });
            return acc;
        }, result);
    }
    result = WiredTemperatureSensor.get
        .where(config, WiredTemperatureSensor.isRealSensor)
        .reduce((acc, current) => {
        const used_io_item = {
            obj_name: current.name,
            io_name: `1-WIRE ${current.serial}`,
            obj_type: 'wired_temperature_sensors',
        };
        return [...acc, used_io_item];
    }, result);
    return result;
    function getNameFromSpec(input_number, block_id) {
        const io_spec = getIOExtensionSpecByBlockId(device_spec, config, block_id);
        const spec = io_spec ?? device_spec.io;
        const arrays = [
            ...spec.inputs,
            ...spec.ntc_inputs,
            ...spec.relay_outputs,
            ...spec.open_collector_outputs,
            //@ts-ignore
            ...(spec.analog_outputs ?? []),
        ];
        const input_name = arrays.find((input) => input.pin_number === input_number)?.text;
        return input_name ?? 'Неизвестно';
    }
}
